import { readStorage, writeStorage } from 'src/services/storage';
import type { ExtParams } from 'src/models';

export const getExtParams = (): ExtParams => {
  return readStorage().extParams;
};

export const setExtParams = (val: ExtParams): void => {
  writeStorage({ extParams: val });
};

export const parseExtParams = (): void => {
  const params = new URLSearchParams(window.location.search);
  if (Array.from(params.entries()).length === 0) return;
  const lat = parseFloat(params.get('lat') || '');
  const lon = parseFloat(params.get('lon') || '');
  const val: ExtParams = {};
  if (!isNaN(lat) && !isNaN(lon)) {
    val.lat = lat;
    val.lon = lon;
  }
  const commentId = params.get('comment_id');
  if (commentId) val.commentId = commentId;
  const movieId = params.get('movie_id');
  const startOffset = parseInt(params.get('start_offset') || '');
  if (movieId && !isNaN(startOffset)) {
    val.movieId = parseInt(movieId);
    val.startOffset = startOffset;
  }
  setExtParams(val);
};
